import { useTranslation } from "react-i18next";
import TeamList from "../components/TeamList";
import { Link } from "react-router-dom";

export default function Team() {
  const { t } = useTranslation();

  return (
    <section className="max-w-6xl mx-auto px-4 py-12 space-y-8">
      <header className="rounded-2xl border border-neutral-800 bg-white/5 backdrop-blur-sm p-6 md:p-8">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h1 className="text-4xl md:text-5xl font-extrabold">{t("team.title")}</h1>
          </div>
          <Link
            to="/#contact-info"
            className="px-5 py-3 rounded-full bg-white text-black font-bold"
          >
            {t("home.cta_contact")}
          </Link>
        </div>
      </header>

      <div className="rounded-2xl border border-neutral-800 p-4 md:p-6">
        {/* Centering is handled inside TeamList now */}
        <TeamList className="mt-2" size="xs" cols="sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4" />
      </div>

      <div className="flex flex-col sm:flex-row items-center gap-3 justify-between">
        <p className="text-neutral-400">{t("company.for_candidates")}</p>
        <div className="flex gap-2">
          <a
            href="https://www.linkedin.com/company/2getters"
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 rounded-full border border-neutral-700 font-semibold hover:bg-white hover:text-black transition"
          >
            {t("contact.linkedin")}
          </a>
        </div>
      </div>
    </section>
  );
}
